import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaEnvelope, FaPhone } from 'react-icons/fa';

const ProctoringViolation = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '500px',
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '15px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        textAlign: 'center'
      }}>
        {/* Warning Icon */}
        <div style={{
          color: '#e74c3c',
          fontSize: '48px',
          marginBottom: '24px',
        //   marginLeft: '70px'
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex'
        }}>
          <FaExclamationTriangle />
        </div>

        {/* Main Message */}
        <h1 style={{
          color: '#2c3e50',
          fontSize: '24px',
          marginBottom: '30px',
          fontWeight: '600',
          lineHeight: '1.4'
        }}>
          Too many proctoring reconnection attempted contact support
        </h1>

        {/* Contact Details Container */}
        <div style={{
          background: '#f8f9fa',
          padding: '25px',
          borderRadius: '12px',
          marginTop: '20px'
        }}>
          {/* Email */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px',
            color: '#34495e',
            fontSize: '16px'
          }}>
            <FaEnvelope style={{ marginRight: '10px', color: '#3498db' }} />
            <span>prompthire.aiInterview@ai</span>
          </div>

          {/* Phone */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#34495e',
            fontSize: '16px'
          }}>
            <FaPhone style={{ marginRight: '10px', color: '#3498db' }} />
            <span>(+91) 62013 29712</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProctoringViolation; 